import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
// import ReCAPTCHA from "react-google-recaptcha";

const ContatoModal = ({ show, handleClose }) => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [segmento, setSegmento] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleCloseModal = () => {
    handleClose();
  };

  // const onChange = (value) => {
  //   console.log("reCAPTCHA value:", value);
  // // };

  const handleSubmit2 = (event) => {
    const dados = {
      channel: {
        type: "WHATSAPP",
          id: "5513997714377"
      },
      id: number,
        name: nome,
          lead: true,
            fields: [
              {
                name: "SegmentoDeAtuao",
                value: segmento
              },
              {
                name: "email",
                value: email
              },
              {
                name: "fonte",
                value: process.env.REACT_APP_FONTE_LEAD
              }
            ]
    };

    fetch("https://app.mzworkspace.com/api/dev/v1/contacts", {
      body: JSON.stringify(dados),
      method: "PUT",
      headers: {
        'customer-token': 'b7d92abd-f806-44be-8542-4ace008a751c',
        'Content-Type': 'application/json'
      }
    }).then(
      (response) => {
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Obrigado pelo contato! 😊",
            text: "Recebemos seu contato, estamos te redirecionando para o WhatsApp.",
            showConfirmButton: false,
            timer: 2500,
          });
          setTimeout(() => {
            setNome("");
            setEmail("");
            setNumber("");
            setSegmento("");
            window.open('https://api.whatsapp.com/send?phone=5513997714377');
          }, 2500);

        } else
          Swal.fire({
            icon: "error",
            title:
              "Erro ao enviar sua solicitação de contato, tente novamente mais tarde!",
            showConfirmButton: false,
            timer: 2500,
          });
      },
      (err) => {
        console.log("FAILED...", err);
        Swal.fire({
          icon: "error",
          title: "Algo deu errado, tente novamente 😢",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    );
  };

  return (
    <>
      {show && (
        <div className="fixed inset-0 flex items-center justify-center" style={{ zIndex: '100' }}>
          <div className="fixed inset-0 bg-black opacity-50"></div>
          <div className="absolute bg-white p-8 rounded-lg shadow-lg z-50">
            <span
              className="absolute top-0 right-0 m-4 cursor-pointer text-gray-600"
              onClick={handleCloseModal}
            >
              &times;
            </span>
            <h2 className="text-xl font-bold mb-4">Entre em Contato Conosco</h2>
            <form onSubmit={handleSubmit(handleSubmit2)}>
              <div className="mb-4">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Nome:
                </label>
                <input
                  {...register("firstName", {
                    required: "Esqueceu seu nome? 🤔",
                  })}
                  type="text"
                  name="firstName"
                  id="firstName"
                  placeholder="Como gostaria de ser chamado?"
                  onChange={(e) => setNome(e.target.value)}
                  value={nome}
                  required
                  className="mt-1 p-2 w-full border rounded-md"
                />
                {errors.firstName && (
                  <span className="text-red-700 absolute">
                    {errors.firstName.message}
                  </span>
                )}
              </div>
              <div className="mb-4">
                <label
                  htmlFor="contact"
                  className="block text-sm font-medium text-gray-700"
                >
                  WhatsApp:
                </label>
                <input
                  {...register("number", {
                    required: "Ops, numero inválido. 🚫",
                  })}
                  type="text"
                  name="number"
                  id="number"
                  autocomplete="number"
                  placeholder="55 (00) 0 0000-0000"
                  onChange={(e) => setNumber(e.target.value)}
                  value={number}
                  required
                  className="mt-1 p-2 w-full border rounded-md"
                />
                {errors.number && (
                  <span className="text-red-700 absolute">
                    {errors.number.message}
                  </span>
                )}
              </div>
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email:
                </label>
                <input
                  {...register("email", {
                    required: "Ops, email inválido. 🚫",
                  })}
                  type="email"
                  name="email"
                  id="email"
                  autocomplete="email"
                  placeholder="Digite seu E-mail mais ativo!"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  required
                  className="mt-1 p-2 w-full border rounded-md"
                />
                {errors.email && (
                  <span className="text-red-700 absolute">
                    {errors.email.message}
                  </span>
                )}
              </div>
              <div className="mb-4">
                <label
                  htmlFor="segmento"
                  className="block text-sm font-medium text-gray-700"
                >
                  Segmento de Atuação:
                </label>
                <input
                  {...register("segmento", {
                    required: "Esqueceu de informar o seu segmento de atuação? 🤔",
                  })}
                  type="text"
                  name="segmento"
                  id="segmento"
                  placeholder="Qual o seu segmento de atuação?"
                  onChange={(e) => setSegmento(e.target.value)}
                  required
                  className="mt-1 p-2 w-full border rounded-md"
                />
                {errors.segmento && (
                  <span className="text-red-700 absolute">
                    {errors.segmento.message}
                  </span>
                )}
              </div>
              {/* <div className="mt-6 mb-6 grid"> */}
              {/* <div
                  class="g-recaptcha"
                  data-sitekey="6LcLZekoAAAAABlPlwhJTBBzMh8K0H9XwmkQmRoK"
                  data-callback="handleRecaptchaResponse"
                ></div> */}
              {/* <ReCAPTCHA sitekey="AIzaSyAo5GaamdicP2m_O3k07xAhLtiGvyjpamI" onChange={onChange} /> */}
              {/* </div> */}
              <button
                type="submit"
                className="bg-blue-500 text-white px-4 py-2 rounded-md"
              >
                Enviar
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ContatoModal;
